import _ from 'underscore';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { filterQuery } from '@culture/common-helpers/url';

import {
	BreadcrumbsPropType,
	MetaPropType,
	NavigationPropType,
	PaginatedItemsPropType,
	PromoBlockPropType
} from 'propTypes/common';

import { Layout, LayoutBlock } from 'components/Layout';
import Breadcrumbs from 'components/Breadcrumbs';
import CatalogTitleHeading from 'components/CatalogTitleHeading';
import Container from 'components/Container';
import GridPromoBlocks from 'components/promoBlocks/GridPromoBlocks';
import MainPromoBlocks from 'components/promoBlocks/MainPromoBlocks';
import SectionCategories from 'components/catalogs/SectionCategories';

import Catalog from './components/Catalog';

import Controls from './components/Controls';

import styles from './styles.module.scss';

const ArticlesTemplate = ({
	breadcrumbs,
	incutGridPromoBlock,
	incutSimplePromoBlock,
	menu,
	meta,
	publications,
	rootRubricPath,
	rubricName,
	topPromoBlock,
	urlParams
}) => {
	const { push } = useRouter();
	const { total } = publications;

	const changeUrl = ({ ...params }) => {
		const queryParams = filterQuery(params);
		const urlPage = `/${rootRubricPath}`;

		push({
			pathname: urlPage,
			query: _(queryParams).pick('query', 'sort', 'cleanCache')
		});
	};

	const handleFilterChange = useCallback(
		(name, value) => {
			const currentValue = urlParams[name] || '';
			if (value !== currentValue) {
				const params = {
					...urlParams,
					[name]: value,
					page: null
				};

				changeUrl(params);
			}
		},
		[urlParams]
	);

	return (
		<Layout {...{ menu, meta, topPromoBlock }}>
			{rootRubricPath.includes('articles') &&
				!_(incutSimplePromoBlock).isEmpty() && (
					<LayoutBlock gutter="none" className={styles.PromoBlock}>
						<Container gutter="adaptiveMobile">
							<MainPromoBlocks blocks={incutSimplePromoBlock} />
						</Container>
					</LayoutBlock>
				)}

			{rootRubricPath.includes('themes') && !_(incutGridPromoBlock).isEmpty() && (
				<LayoutBlock gutter="none" className={styles.PromoBlock}>
					<Container gutter="adaptiveMobile">
						<GridPromoBlocks blocks={incutGridPromoBlock} />
					</Container>
				</LayoutBlock>
			)}

			<SectionCategories
				rubricName={rubricName}
				showAccessibilityCard={false}
			/>

			<LayoutBlock gutter="none">
				<Container>
					<Breadcrumbs
						items={breadcrumbs}
						currentPath={rootRubricPath}
						showAllItems
					/>
				</Container>
			</LayoutBlock>

			<LayoutBlock gutter="mediumConstant">
				<Container innerClassName={styles.Title}>
					<CatalogTitleHeading
						{...{ headingTitle: meta?.headingTitle, total }}
					/>
				</Container>
			</LayoutBlock>

			<LayoutBlock gutter="mediumConstant">
				<Container>
					<Controls
						{...{
							urlParams,
							handleFilterChange
						}}
					/>
				</Container>
			</LayoutBlock>

			<LayoutBlock>
				<Container>
					<Catalog {...{ publications }} />
				</Container>
			</LayoutBlock>
		</Layout>
	);
};

ArticlesTemplate.propTypes = {
	breadcrumbs: BreadcrumbsPropType.isRequired,
	incutGridPromoBlock: PropTypes.array,
	incutSimplePromoBlock: PropTypes.array,
	menu: NavigationPropType.isRequired,
	meta: MetaPropType.isRequired,
	publications: PaginatedItemsPropType,
	rootRubricPath: PropTypes.string,
	rubricName: PropTypes.string,
	topPromoBlock: PromoBlockPropType,
	urlParams: PropTypes.object.isRequired
};

export default ArticlesTemplate;
